export const language = {
  zh: {
    'Application time': '申请时间',
    'UserName': '员工姓名',
    'Contact information': '联系方式',
    'Remark': '备注',
    'Audit status': '审核状态',
    'Audit reason': '审核理由',
    'Operation': '操作',
    'Review account association applications': '帐号关联申请审核',
    'Pass': '审核通过',
    'Refuse': '审核拒绝',
    'Reason': '理由',
    'Cancel': '取消',
    'Confirm': '确认',
    'To be reviewed': '待审核',
    'Please Entry': '请输入',
    'Are you sure to Confirm': '确认审核通过'
  },
  en: {
    'Application time': 'Application time',
    'UserName': 'UserName',
    'Review account association applications': 'Review account association applications',
    'Contact information': 'Contact information',
    'Remark': 'Remark',
    'Audit status': 'Audit status',
    'Audit reason': 'Audit reason',
    'Operation': 'Operation',
    'Pass': 'Pass',
    'Refuse': 'Refuse',
    'Reason': 'Reason',
    'Cancel': 'Cancel',
    'Confirm': 'Confirm',
    'To be reviewed': 'To be reviewed',
    'Please Entry': 'Please Entry',
    'Are you sure to Confirm': 'Are you sure to Confirm'
  }
};